<template>
  <div class="ses">
    <table>
      <thead>
        <tr>
          <td>SES</td>
          <td>Traffic</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="i in 5" :key="i">
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  name: 'adx-dashboard-campaignreport-ses',
  components: {

  },
  props: {

  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>